import { render, staticRenderFns } from "./Boxes.vue?vue&type=template&id=4ad5afee&scoped=true&"
import script from "./Boxes.vue?vue&type=script&lang=ts&"
export * from "./Boxes.vue?vue&type=script&lang=ts&"
import style0 from "./Boxes.vue?vue&type=style&index=0&id=4ad5afee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad5afee",
  null
  
)

export default component.exports